// CartasSpa.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const CartasSpa = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://sites.google.com/iberostar.com/cam/carta-de-bebidas-drinks-menu",
    en: "https://sites.google.com/iberostar.com/cam/carta-de-bebidas-drinks-menu",
  };
  return (
    <>
      <button
        className="full-width-button"
        onClick={() => setShowModal(true)}
      >
        <i className="bi bi-journal-text icon-space" /> 
        Carta de Bebidas/ Drinks Menu
      </button>
      {showModal && (
        <LanguageModal
          title="Carta de Bebidas/ Drinks Menu"
           icon="bi bi-journal-text"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default CartasSpa;
